import { render } from "./DemoOverlayComponent.vue?vue&type=template&id=5ab11aee&scoped=true&ts=true"
import script from "./DemoOverlayComponent.vue?vue&type=script&lang=ts"
export * from "./DemoOverlayComponent.vue?vue&type=script&lang=ts"

import "./DemoOverlayComponent.vue?vue&type=style&index=0&id=5ab11aee&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab11aee"]])

export default __exports__